/** Shared HUD / dialog typography — keep in sync with `client/index.html` body font stack. */
export const UI_FONT =
  '"Inter", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

export const UI_TEXT = {
  primary: "#f0f2f8",
  secondary: "#c8cedc",
  muted: "#9aa3b5",
  player: "#ffd54a",
  link: "#8ab4ff",
  danger: "#ff9a9a",
} as const;

export const UI_SURFACE = {
  panel: 0x161b28,
  panelStroke: 0x3d4a62,
  transcript: 0x0e1118,
  transcriptStroke: 0x2e3648,
  btnPrimary: "#2d4a7a",
  btnSecondary: "#2a3142",
  btnGhost: "#1e2433",
  btnClose: "#252d3d",
} as const;
